import React from 'react';
import { AlertTriangleIcon, BoxesIcon, ClockIcon, InfoIcon } from 'lucide-react';
import { useProto } from '../../contexts/PrototypeContext';
type Kind = 'unresolved' | 'placeholder' | 'rule' | 'note';
interface AnnotationProps {
  kind: Kind;
  title: string;
  children?: React.ReactNode;
  className?: string;
}
const kinds: Record<Kind, {
  label: string;
  Icon: typeof InfoIcon;
  cls: string;
}> = {
  unresolved: {
    label: 'Unresolved',
    Icon: AlertTriangleIcon,
    cls: 'border-note-line bg-note-bg text-note-ink'
  },
  placeholder: {
    label: 'Placeholder',
    Icon: ClockIcon,
    cls: 'border-note-line bg-note-bg text-note-ink'
  },
  rule: {
    label: 'Business rule',
    Icon: InfoIcon,
    cls: 'border-note-ruleLine bg-note-ruleBg text-note-ruleInk'
  },
  note: {
    label: 'Design note',
    Icon: BoxesIcon,
    cls: 'border-note-noteLine bg-note-noteBg text-note-noteInk'
  }
};
export function Annotation({
  kind,
  title,
  children,
  className = ''
}: AnnotationProps) {
  const {
    state
  } = useProto();
  if (!state.showAnnotations) return null;
  const {
    label,
    Icon,
    cls
  } = kinds[kind];
  return <aside role="note" className={`rounded-md border border-dashed px-3 py-2 font-proto text-[12px] leading-snug ${cls} ${className}`} data-id="element-449" data-mp="1l5kkde0t4la2">
      <div className="flex items-start gap-2" data-id="element-450" data-mp="1yy0o6h1j8nc1">
        <Icon className="mt-[1px] h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-451" data-mp="1yytp31dt8im9" />
        <div className="min-w-0" data-id="element-452" data-mp="1u4xt24h3x5tq">
          <p className="font-semibold" data-id="element-453" data-mp="28v50zq9hn6g6">
            <span className="mr-1.5 text-[10px] uppercase tracking-wide opacity-80" data-id="element-454" data-mp="28u3mtcx6e3u8">{label}</span>
            {title}
          </p>
          {children && <div className="mt-0.5 opacity-90" data-id="element-455" data-mp="23yelp55icevt">{children}</div>}
        </div>
      </div>
    </aside>;
}